import { useDataSource } from '@/contexts/DataSourceContext';

/**
 * Hook to get the data mode for a specific screen
 * 
 * Usage:
 * ```tsx
 * const { mode, isDemo, isLive } = useScreenDataMode('homepage');
 * 
 * // Use the mode to determine data source
 * if (isDemo) {
 *   // Fetch from mock data
 *   return mockData;
 * } else {
 *   // Fetch from API
 *   return await fetchFromAPI();
 * }
 * ```
 * 
 * @param screenId - The ID of the screen (e.g., 'homepage', 'timesheet', 'reports-timesheet')
 * @returns Object containing mode, isDemo, and isLive flags
 */
export const useScreenDataMode = (screenId: string) => {
  const { getScreenMode, isModeLocked } = useDataSource();
  const mode = getScreenMode(screenId);

  return {
    mode,
    isDemo: mode === 'demo',
    isLive: mode === 'live',
    isModeLocked,
  };
};
